'use client';

import { createContext, useContext, type ReactNode } from 'react';

import { ALL_RENTALS_SLUG } from './allRentalsSlug';

const AllRentalsSlugContext = createContext<string>(ALL_RENTALS_SLUG);

/** Hands the all-rentals slug to client search code. */
export function AllRentalsSlugProvider({ slug, children }: { slug: string; children: ReactNode }) {
  return <AllRentalsSlugContext.Provider value={slug}>{children}</AllRentalsSlugContext.Provider>;
}

export function useAllRentalsSlug(): string {
  return useContext(AllRentalsSlugContext);
}
